import React from "react";
import PropTypes from "prop-types";
import { Image } from "@learningblocks/shared-components";
import { PlainText } from "@learningblocks/storybook-components";
import cname from "./style.module.scss";

/**
 * Experimental-Design FullWidthImage component:
 */
export function FullWidthImage(props) {
  const className = `${cname.fullWidthImage} ${props.className}`;

  if (props.caption) {
    return (
      <figure className={className}>
        <Image src={props.image} alt="figure" width="100%" />
        <PlainText text={props.caption} />
      </figure>
    );
  } else {
    return (
      <Image
        tabIndex="0"
        src={props.image}
        alt="figure"
        className={className}
        width="100%"
      />
    );
  }
}

FullWidthImage.propTypes = {
  /**
   * String repersenting type of component
   */
  type: PropTypes.string,
  /**
   * Repersenting requiered array of contents
   */
  content: PropTypes.array,
  /**
   * Url to the image.
   */
  image: PropTypes.string.isRequired,
  /**
   * String repersenting classname of the image
   */
  className: PropTypes.string,
  /**
   * caption of the image
   */
  caption: PropTypes.string,
};

FullWidthImage.defaultProps = {
  type: "FULL_WIDTH_IMAGE",
};
